import { Link } from '@/components/link';
import {
  AddLinkOutlined,
  LocalOfferOutlined,
} from '@/constants/hardfin-standard-icons';
import { useDisclosure } from '@/hooks/use-disclosure';
import { Ticket } from '@/ticket/api/types';
import { TicketProjectsDialog } from '@/ticket/components/dialogs/ticket-projects-dialog';
import {
  Box,
  Button,
  Card,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';

interface Props {
  ticket: Ticket;
}

export function TicketDetailProjectsAttached(props: Props) {
  const dialog = useDisclosure(false);
  const ticket = props.ticket;
  return (
    <Card variant="outlined" sx={{ flex: 1 }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, p: 3 }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography variant="h6">Projects</Typography>
          <TicketProjectsDialog
            ticket={props.ticket}
            isOpen={dialog.isOpen}
            onClose={dialog.close}
          />
          <Button
            variant="outlined"
            size="small"
            startIcon={<AddLinkOutlined />}
            onClick={() => dialog.open()}
          >
            Attach
          </Button>
        </Box>
        {ticket.projects.length === 0 ? (
          <Typography variant="body2" color="text.secondary">
            No projects attached
          </Typography>
        ) : (
          <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
            {ticket.projects.map((project) => (
              <Box key={project.key} sx={{ width: '50%' }}>
                <ListItem sx={{ py: 0.5 }}>
                  <ListItemIcon sx={{ minWidth: 32 }}>
                    <LocalOfferOutlined fontSize="small" color="action" />
                  </ListItemIcon>
                  <Link
                    to="/projects/$projectKey"
                    params={{ projectKey: project.key }}
                    color="primary.main"
                    variant="body2"
                  >
                    <ListItemText
                      primary={`${project.name}`}
                      primaryTypographyProps={{ variant: 'body2' }}
                    />
                  </Link>
                </ListItem>
              </Box>
            ))}
          </Box>
        )}
      </Box>
    </Card>
  );
}
